import { gql } from '@apollo/client';

export const ALL_SP_INSIGHTS = gql`
  query allSPInsights($input: getInsightsInput!) {
    insights: allSPInsights(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          users {
            id
            firstName
            lastName
          }
          tags {
            id
            name
          }
          url
          createdBy {
            id
            firstName
            lastName
          }
          createdOn
        }
      }
    }
  }
`;
